// src/Login.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Login = ({ setAuthToken }) => {
    const [token, setToken] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [shopOpen, setShopOpen] = useState(false);

    // check if there is a token in the cookie, if so, set it as the token
    useEffect(() => {
        var cookieToken = getCookie('token');
        if (cookieToken) {
            console.log('cookieToken: ' + cookieToken);
            setAuthToken(cookieToken);
            setToken(cookieToken);
        }
    }, []); // Empty dependency array means this effect runs only once on mount

    const handleLogin = (e) => {
        e.preventDefault();
        setErrorMessage('');
        const token = 'Basic ' + btoa(username + ':' + password);
        //setAuthToken(token);
        //navigate('/products');
        const url = process.env.REACT_APP_BASE_API_URL + 'ApplicationParams/shopOpen';

        // Assuming there's an endpoint /api/auth to validate the token
        fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': token,
            },
        })
            .then(async response => {
                if (response.ok) {
                    const data = await response.json();
                    setShopOpen(data.value === "True");

                    setAuthToken(token);
                    setToken(token);

                    // Calculate expiration date for 16 hours from now
                    const date = new Date();
                    date.setTime(date.getTime() + (16 * 60 * 60 * 1000)); // 16 hours in milliseconds
                    const expires = "expires=" + date.toUTCString();
                    // Set cookie with expiration
                    document.cookie = "token=" + token + ";" + expires + ";path=/";
                } else {
                    throw new Error('Invalid credentials');
                }
            })
            .catch(error => {
                setErrorMessage('Username or password incorrect');
            });
    };

    function toggleShopTo(val, stateStr) {
        const userConfirmed = window.confirm(`Are you sure you want to ${stateStr} the shop?`);
        if (userConfirmed) {
            const url = process.env.REACT_APP_BASE_API_URL + 'ApplicationParams';

            // Assuming there's an endpoint /api/auth to validate the token
            fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token,
                },
                body: JSON.stringify({ key: 'shopOpen', value: val }),
            })
                .then(response => {
                    // handle response
                    console.log("success")
                })
                .catch(error => {
                    console.error('There was an error!', error);
                });

            setShopOpen(val === "True");
        }
    }

    function toggleShopOpen() {
        toggleShopTo("True", "OPEN");
    }

    function toggleShopClosed() {
        toggleShopTo("False", "CLOSE");
    }

    return (
        <div>
            {errorMessage && <p>{errorMessage}</p>}
            {!token && <form onSubmit={handleLogin}>
                <h2>Login</h2>
                <div>
                    <label>Username:</label>
                    <input
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                </div>
                <div>
                    <label>Password:</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>
                <button type="submit">Login</button>
            </form>}

            {token &&
                <div>
                    <h2>Admin actions:</h2>
                    <nav>
                        <ul>
                            <li><Link to="/products">Edit Products</Link></li>
                            <li><Link to="/upload">Upload MenuList</Link></li>
                            {shopOpen && <li><a href="#" onClick={toggleShopClosed}>Shop is OPEN ; click to Close shop</a></li>}
                            {!shopOpen && <li><a href="#" onClick={toggleShopOpen}>Shop is CLOSED ; click to Open shop</a></li>}
                            <li><a href="#" onClick={logout}>Logout</a></li>

                        </ul>
                    </nav>
                </div>}
        </div>
    );
};

function getCookie(name) {
    let cookieArray = document.cookie.split(';'); // Split document.cookie string into an array by ';'
    for (let i = 0; i < cookieArray.length; i++) {
        let cookiePair = cookieArray[i].trim().split('='); // Split each individual cookie into a name/value pair
        if (cookiePair[0] === name) {
            return cookiePair[1]; // Return the value if the name matches
        }
    }
    return null; // Return null if the cookie with the given name is not found
}

function logout() {
    document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    // Optionally, redirect the user to the login page or refresh the page
    window.location.href = '/login'; // Redirect to login page
}


export default Login;